import React from 'react';
import CardContainer, { StyledTypography } from './styles';
import LabelTitle from '../../Titles/LabelTitle';
import { Typography, IconButton } from '@material-ui/core';
import Linkedin from '../../../assets/icons/linkedin.png';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const Person = ({ image, name, label, description, linkedin }) => (
	<CardContainer>
		<div className="card__image">
			<IconButton aria-label="arrow-rigth" className="button__arrow-rigth">
				<ArrowForwardIcon />
			</IconButton>
			<img src={image} alt="Person" className="card__image" />
		</div>
		<div className="card__data">
			<div className="card__hover">
				<StyledTypography variant="h1">{name}</StyledTypography>
				<LabelTitle content={label} />
				<Typography className="card__description">{description}</Typography>
				{linkedin && (
					<a
						href={linkedin}
						target="_blank"
						className="socialnetwork"
						rel="noopener noreferrer"
					>
						<img src={Linkedin} alt="Linkedin" />
					</a>
				)}
			</div>
		</div>
	</CardContainer>
);

export default Person;
